import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Icon, Progress, Spin, message, Divider, Badge } from 'antd';
import QueueAnim from 'rc-queue-anim';
import ExcelForm from './ExcelForm';
import NHModal from '../../common/NHModal';
import NHFetch from '../../../utils/NHFetch';
import { getLoginUser } from '../../../utils/NHCore';
import { baseUrl } from '../../../utils/NHPrefixUrl';

/**
 * 导入控件
 * Author: yizhiqiang@ly-sky.com
 * Created on: 创建时间 
 * Version: 1.0
 * Modify log:
 *  2018-08-30 by zengxiangkai@ly-sky.com:
 *      1、修改导入反馈信息提示
 *      2、调整代码格式
 */
export default class NBExcel extends Component {
    //设置可以传递参数的默认值
    static defaultProps = {
        title:undefined,//导入控件的标题
        templateUrl:undefined,//导入模板下载路径
        templateName:undefined,//导入模板名称
        templateSign:undefined,//导入模板问标志，主要通过该标志获取文件
        onCancel:undefined,//关闭Excel导入控件的回调事件
        onSuccess:undefined,//导入成功时的回调事件
        formItemList:undefined,//自定义参数表单，格式：[{label:'类型',key:'key',required:true,message:'错误信息提示',initialValue:'1',render:()=>{ return <Input></Input>}}]
        description:undefined,//描述，格式：['第一行的提示','第二行的提示',<font color="red">第三行描述</font>]
        importUrl:undefined,//導入控件的url
        params:{},//初始化参数
    }

    constructor(props) {
        super(props)
        this.state = {
            uuid: undefined,//上传文件的uuid
            btnDisabled: false,
            loading: false,
            importFlag: true,
            runningFlag: false,
            resultFlag: false,
            totalCount: undefined,
            successCount: undefined,
            errorCount: undefined,
            errorFileName: undefined,
            errorFileUuid: undefined,
            percent: 0,
            processTip: '导入中',
            importStatus: 'prepare',//导入状态，prepare：准备中，uploading:导入中，success:导入成功，error:导入成功
        }
    }

    show = () => {
        this.setState({
            uuid: undefined,//上传文件的uuid
            btnDisabled: false,
            loading: false,
            importFlag: true,
            runningFlag: false,
            resultFlag: false,
            totalCount: undefined,
            successCount: undefined,
            errorCount: undefined,
            errorFileName: undefined,
            errorFileUuid: undefined,
            percent: 0,
            processTip: '导入中',
            importStatus: 'prepare',//导入状态，prepare：准备中，uploading:导入中，success:导入成功，error:导入成功

        });
        this.refs.nhModal.show();
    }

    //保存按钮事件
    handleSave = () => {
        let userId = getLoginUser().userId;
        if (!userId) {
            message.info("登录已过期，请重新登录！");
            return;
        }
        this.nhForm.validateFields((err, values) => {
            if (!err) {
                let uuid = values.uuid.split(";")[0];
                let otherParams = values;
                delete otherParams.uuid;
                let params = {
                    uuid: uuid,
                    userId: userId,
                    params: otherParams
                }
                this.setState({
                    importFlag: false,
                    runningFlag: true,
                    resultFlag: false,
                    importStatus: 'uploading',
                    loading: true,
                    uuid: uuid,
                }, () => {
                    //加载导入进度的进度条
                    this.loadProcessStatus();
                });
                NHFetch(this.props.importUrl, "POST", params)
                    .then((res) => {
                        if (res) {
                            if (res.code && res.code == 200) {
                                this.setState({
                                    totalCount: res.data.totalCount,
                                    successCount: res.data.successCount,
                                    errorCount: res.data.errorCount,
                                    errorFileName: res.data.errorFileName,
                                    errorFileUuid: res.data.errorFileUuid,
                                    importStatus: 'success'
                                });
                                if (this.props.onSuccess) {
                                    this.props.onSuccess();
                                }
                            } else {
                                Modal.error({
                                    title: '错误提示',
                                    content: '本次导入操作失败，请重新导入！',
                                });
                                this.setState({
                                    importStatus: 'error'
                                });
                            }
                        }
                    })
                    .catch(() => {
                        this.setState({
                            importStatus: 'error',
                        });
                    });
                //加载前面的10%，默认分两秒钟完成
                let iter = setInterval(() => {
                    if (this.state.percent >= 10) {
                        window.clearInterval(iter)
                    } else {
                        let percent = this.state.percent + 1;
                        this.setState({
                            percent: percent,
                        });
                    }
                }, 100)

            }
        });
    }

    /**
     * * 更新导入状态
     *
     * @memberof NBExcel
     */
    loadProcessStatus = () => {
        NHFetch(baseUrl + "/proData/getProgressStatus", "GET", { uuid: this.state.uuid })
            .then((res) => {
                if (res) {
                    //说明已经结束了
                    if (this.state.importStatus == 'success' || this.state.importStatus == 'error') {
                        this.setState({
                            resultFlag: true,
                            percent: 100,
                            processTip: '导入结束',
                            loading: false,
                            btnDisabled: true,
                        });
                    } else {
                        //还要继续轮训查询
                        if (res.data && (res.data.percent != this.state.percent || res.data.processTip != this.state.processTip)) {
                            this.setState({
                                percent: res.data.percent,
                                processTip: res.data.processTip
                            });
                        }
                        setTimeout(() => {
                            this.loadProcessStatus();
                        }, 1000)
                    }
                }
            })
            .catch(() => {

                //说明已经结束了
                if (this.state.importStatus == 'success' || this.state.importStatus == 'error') {
                    this.setState({
                        resultFlag: true,
                        percent: 100,
                        processTip: '导入结束',
                        loading: false,
                        btnDisabled: true,
                    });
                } else {
                    setTimeout(() => {
                        this.loadProcessStatus();
                    }, 1000)
                }
            });
    }


    //弹窗关闭事件
    handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    //暂时保留
    onExcelChange = (resultStr) => {
        this.setState({
            uuid: resultStr.split(";")[0]
        });
    }


    render() {

        const {totalCount, successCount, errorCount} = this.state;
        let templateUrl = this.props.templateUrl?this.props.templateUrl:window.baseUrl+'/proData/getTemplate?fileName='+encodeURI(encodeURI(this.props.templateName))+'&sign='+encodeURI(encodeURI(this.props.templateSign));
        let errorUrl = baseUrl + '/proData/getExcelErrorFile?uuid=' + this.state.errorFileUuid;
        let footer = [
            {
                text: '返回', type: undefined, onClick: () => {
                    this.refs.nhModal.close()
                    if (this.props.onCancel) {
                        this.props.onCancel();
                    }
                }
            },
            { text: '导入', type: 'primary', onClick: this.handleSave, disabled: this.state.btnDisabled, loading: this.state.loading }
        ];

        return (
            <NHModal
                ref="nhModal"
                title={this.props.title ? this.props.title : '导入面板'}
                width={600}
                onCancel={this.handleCancel}
                footer={footer}
            >
                <div>
                    <div style={{ display: this.state.importFlag ? '' : 'none' }}>
                        <Row style={{ margin: '10px 0', padding: '5px 0' }}>
                            <Col style={{ paddingLeft: '30px' }}><Icon type="info-circle" style={{ color: '#FFCD19' }} />上传文件需要按照模板上传，如果还没有模板，可以先 <a href={templateUrl} target={'_blank'}> <Icon type="download"  />下载模板</a> </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <ExcelForm ref={form => this.nhForm = form} formItemList={this.props.formItemList}></ExcelForm>
                            </Col>
                        </Row>
                        {
                            (this.props.description && this.props.description.length > 0) ?
                                <Row>
                                    <Col span={24} style={{ margin: '0 0', padding: '5px 0' }}>
                                        <Divider style={{ margin: '0px' }}></Divider>
                                    </Col>
                                </Row>
                                : null
                        }
                        {
                            (this.props.description && this.props.description.length > 0) ?
                                <Row>
                                    <Col span={2}>
                                        备注：
                                </Col>
                                    <Col span={22}>
                                        {
                                            this.props.description.map((item, index) => {
                                                return <font>{index + 1}、{item}<br /></font>
                                            })
                                        }
                                    </Col>
                                </Row>
                                : null
                        }
                    </div>
                    <div style={{ display: this.state.runningFlag ? '' : 'none', height: '205px' }}>
                        <font style={{ fontWeight: 'bold', color: '#323232', fontSize: '15px' }} >导入状态：</font>
                        <font style={{ color: '#1890FF', fontSize: '15px' }}>{this.state.processTip}</font><br />
                        <Progress percent={this.state.percent} strokeWidth={15} />
                        <div style={{ display: this.state.resultFlag ? 'none' : '', width: '100%', height: '80px', lineHeight: '80px', textAlign: 'center' }}>
                            <Spin size="large" tip={'上传中...'} />
                        </div>
                        <div style={{ display: this.state.resultFlag ? '' : 'none', marginTop: 15 }}>
                            <QueueAnim delay={300} className="queue-simple">
                                <font key="a" style={{ fontWeight: 'bold', color: '#323232', fontSize: '15px' }}>导入详情：<br /></font>
                                <font key="b" style={{ lineHeight: '30px', fontSize: '15px' }}>
                                    <Badge status="warning" />文件数据条数：
                                    <font style={{ fontWeight: 'bold', color: '#323232', fontStyle: 'italic' }}>{totalCount}</font><br />
                                </font>
                                <font key="c" style={{ lineHeight: '30px', fontSize: '15px' }}>
                                    <Badge status="processing" />成功数据条数：
                                    <font style={{ fontWeight: 'bold', color: '#09B2F0', fontStyle: 'italic' }}>{successCount}</font><br />
                                </font>
                                <font key="d" style={{ lineHeight: '30px', fontSize: '15px' }}>
                                    <Badge status="error" />错误数据条数：
                                    <font style={{ fontWeight: 'bold', color: '#FA0101', fontStyle: 'italic' }}>{errorCount}</font><br />
                                </font>
                                {
                                    this.state.errorFileUuid ? <font key="f">
                                        <font style={{ fontWeight: 'bold', color: '#323232', fontSize: '15px' }}>可点击：</font>
                                        <a href={errorUrl} target={'_blank'} style={{ color: '#1B8FFF', fontSize: '15px' }}>{this.state.errorFileName}</a><br /></font> : ''
                                }
                                {
                                    this.state.errorFileUuid ? <font key="g" style={{ color: '#999999', fontSize: '15px' }}>下载错误文档，查看错误详情</font> : ''
                                }
                            </QueueAnim>
                        </div>
                    </div>

                </div>
            </NHModal>
        )
    }
}

/** 
 * 默认属性 
 */
NBExcel.defaultProps = {
    title: 'Excel', //导入控件的标题
    onCancel: () => { }, //关闭Excel导入控件的回调事件
    onSuccess: () => { }, //导入成功时的回调事件
}

/**
 * 属性检查
 */
NBExcel.PropTypes = {
    title: PropTypes.string,//导入控件的标题
    templateUrl: PropTypes.string,//导入模板下载路径
    templateName: PropTypes.string,//导入模板名称
    onCancel: PropTypes.func,//关闭Excel导入控件的回调事件
    onSuccess: PropTypes.func,//导入成功时的回调事件
    formItemList: PropTypes.array,//自定义参数表单，格式：[{label:'类型',key:'key',required:true,message:'错误信息提示',initialValue:'1',render:()=>{ return <Input></Input>}}]
    description: PropTypes.array,//描述，格式：['第一行的提示','第二行的提示']
}


// WEBPACK FOOTER //
// ./components/mailingManagement/NHExcel/index.js